module.exports = __webpack_public_path__ + "img/tag1.8c6c092a.png";